import { ReactElement } from "react"

import AppPaper from "../surfaces/appPaper"

/**
 * Displayed when invalid URL entered. Called
 * by app router in `src/router`
 *
 * @example
 * <PageNotFound />
 */
const PageNotFound = (): ReactElement => (
    <AppPaper>Not found! This URL does not exist</AppPaper>
)
export default PageNotFound
